"use client"

import Link from "next/link"

export default function CollectorAvatarWrapper({
  children,
  postId,
  blogSlug,
}: {
  children: React.ReactNode
  postId: string
  blogSlug: string
}) {
  return (
    <Link href={`/${decodeURIComponent(blogSlug)}/collectors/${postId}`}>
      <div className="open-collect-modal cursor-pointer collectors">
        {children}
      </div>
    </Link>
  )
}
